// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const NotificationType = {
  "EMAIL": "EMAIL",
  "PUSHNOTIFICATION": "PUSHNOTIFICATION"
};

const TransferRequestStatus = {
  "REQUESTED": "REQUESTED",
  "COLLECTED": "COLLECTED",
  "COMPLETED": "COMPLETED",
  "CANCELED": "CANCELED"
};

const CustomerZone = {
  "BLM": "BLM",
  "CPT": "CPT",
  "DBN": "DBN",
  "EL": "EL",
  "JNB": "JNB",
  "PE": "PE",
  "GRG": "GRG"
};

const CustClass = {
  "A": "A",
  "B": "B",
  "C": "C",
  "D": "D",
  "H": "H",
  "L": "L",
  "Z": "Z"
};

const LocationType = {
  "NATIONAL": "NATIONAL",
  "REGIONAL": "REGIONAL"
};

const UserRole = {
  "TECH": "TECH",
  "ADMIN": "ADMIN",
  "MOBILE": "MOBILE",
  "REGIONALMANAGER": "REGIONALMANAGER",
  "PORTALREADONLY": "PORTALREADONLY"
};

const TaskType = {
  "STATUS_CHECK": "STATUS_CHECK",
  "UPLIFTMENT": "UPLIFTMENT",
  "IMPLEMENT": "IMPLEMENT",
  "TRANSFER": "TRANSFER"
};

const Status = {
  "NEW": "NEW",
  "GOOD": "GOOD",
  "BAD": "BAD",
  "MISSING": "MISSING",
  "DECOMMISSIONED": "DECOMMISSIONED"
};

const TaskStatus = {
  "OPEN": "OPEN",
  "COMPLETED": "COMPLETED",
  "BUSY": "BUSY",
  "CANCELED": "CANCELED"
};

const Owner = {
  "REP": "REP",
  "CUSTOMER": "CUSTOMER",
  "WAREHOUSE": "WAREHOUSE",
  "THIRDPARTY": "THIRDPARTY"
};

const ResultStatus = {
  "PENDING": "PENDING",
  "COMPLETE": "COMPLETE",
  "ERROR": "ERROR"
};

const { Task, TaskItem, TransferRequest, Notification, Customer, Brand, ThirdParty, User, Element, Warehouse, Stock, StockMovement, TaskLog, ReferenceNumber, TransferItem, TaskNextStep } = initSchema(schema);

export {
  Task,
  TaskItem,
  TransferRequest,
  Notification,
  Customer,
  Brand,
  ThirdParty,
  User,
  Element,
  Warehouse,
  Stock,
  StockMovement,
  TaskLog,
  ReferenceNumber,
  NotificationType,
  TransferRequestStatus,
  CustomerZone,
  CustClass,
  LocationType,
  UserRole,
  TaskType,
  Status,
  TaskStatus,
  Owner,
  ResultStatus,
  TransferItem,
  TaskNextStep
};